import React, { useState, useEffect } from 'react';
import { fetchProducts } from 'services/carePackage';
import ProductCard from '../components/ProductCard';

const SelectPackage = ({ onSelect }) => {
    const [products, setProducts] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetchProducts()
            .then(fetched => {
                if (!cancelled) setProducts(fetched);
            })
            .catch(() => {
                if (!cancelled) setProducts([]);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (products === null) {
        return <div className="care-package-loading">Loading packages&hellip;</div>;
    }

    const sorted = [...products].sort((a, b) => b.price - a.price);

    return (
        <div className="care-package-select-package">
            {sorted.length === 0 ? (
                <div className="care-package-empty">No packages available</div>
            ) : (
                <div className="care-package-product-grid">
                    {sorted.map(product => (
                        <ProductCard key={product.id} product={product} onSelect={onSelect} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectPackage;
